import { ErrorBoundary } from "@sentry/react";
import { Card } from "antd";
import { ProjectContext } from "context/ProjectProvider";
import { TFetureDetailUpdateAction } from "entity-app/models";
import EntityDateblockNewInterface from "entity-app/shared-components/entity-dateblock/entity-dateblock-new-interface";
import { TGoverningSource } from "entity-app/shared-components/entity-dateblock/models";
import { getTypeOfGoverningSourceTitle } from "entity-app/utils/utils";
import { useContext, useMemo, useState } from "react";

function DesignLinkedTopSection(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  disabled: boolean;
}) {
  const { featureInstanceData, actions, disabled } = props;
  const [tempDisable, setTempDisable] = useState(false);
  const {
    columnHeaders: { designPackageHeaderMap }
  } = useContext(ProjectContext);

  const governingSource: TGoverningSource | undefined = useMemo(() => {
    const governingTask = (
      featureInstanceData?.links_as_source as Array<any>
    )?.find((x) => x.governing_link);

    if (governingTask) {
      return {
        id: governingTask.target_feature_instance.feature_workflow_instance
          .feature_instance_id,
        name: governingTask.target_feature_instance.title,
        type: getTypeOfGoverningSourceTitle(
          governingTask.target_feature_instance.feature_type_id
        ),
        isLinkedEndDate: governingTask.link_type === 2
      };
    }
    if (featureInstanceData?.feature_workflow_instance?.manual_entry_date) {
      return {
        id: featureInstanceData.feature_workflow_instance.feature_instance_id,
        name: "Manually Set Date",
        type: "Manually Set Date"
      };
    }
    return undefined;
  }, [featureInstanceData]);

  if (!featureInstanceData) return null;

  return (
    <Card
      title="Design Package Schedule"
      styles={{ body: { padding: 0 } }}
      className="ciq-card-block"
    >
      <div className="w-full h-[470px] flex">
        <div className="grow h-full overflow-auto">
          <div className="overflow-auto px-3 flex h-full items-center">
            <ErrorBoundary>
              <EntityDateblockNewInterface
                entity={featureInstanceData}
                afterChange={() => {
                  actions.refetchFeatureInstanceData();
                }}
                governingSource={governingSource}
                permissions={
                  tempDisable
                    ? {}
                    : {
                        canEditActualDate: !disabled,
                        canEditDurations: !disabled,
                        canEditCommittedDate: !disabled
                      }
                }
                setApiCallLoading={setTempDisable}
                entityHeaders={designPackageHeaderMap}
              />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </Card>
  );
}
export default DesignLinkedTopSection;
